import { APIClient } from "./axiosClient";
const api = new APIClient();

const path = "event-logs";
const eventLogApi = {
  eventLogs(params: any): Promise<any> {
    const url = `${path}`;
    return api.get(url, params);
  },

  eventLogsNew(params: any): Promise<any> {
    const url = `${path}/migration`;
    return api.get(url, params);
  },

  countries(params: any): Promise<any> {
    const url = `${path}/country-codes`;
    return api.get(url, params);
  },
};

export default eventLogApi;
